const getWebsiteProtocol = (website) => {
  const { alias } = website;

  return alias.match(/.\.pics\.io/) ? 'https://' : 'http://';
};

export default getWebsiteProtocol;
